export const ACCESS_PORTAL = 'gdsv5/util/igetclientdetails';

export const THEME_GET_THEME_SETTINGS = 'gdsv5/theme/getthemesettings';

export const KMBD_ADDRESS = 'kmbd/address';

export const KMBD_COLLECTION_DAY = 'kmbd/collectionDay';

export const KMBD_CALENDER_DATA = 'gdsv5/service/getkmbdcalendar';

export const THEME_GET_FOOTER_PAGE_DATA = 'gdsv5/theme/getfooterpagedata';
